'use client';

import { useSyncExternalStore } from 'react';

import { isInIframe } from '@/utils/iframe-detection';

const emptySubscribe = () => () => {};
const getSnapshot = () => isInIframe();
const getServerSnapshot = () => false;

/**
 * Hook that detects if the application is running inside an iframe.
 * Uses useSyncExternalStore to safely handle SSR hydration.
 *
 * @returns true if running in iframe, false otherwise (including SSR)
 */
export default function useIsIframe(): boolean {
  return useSyncExternalStore(emptySubscribe, getSnapshot, getServerSnapshot);
}
